var $d6d2588377fc9718$exports = {};
$d6d2588377fc9718$exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};


export {$d6d2588377fc9718$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
